import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
    researchMenuItems,
    adminMenuItems,
    corporateMenuItems,
    hiddenRoutes,
    getRouteComponent,
    salesMenuItems,
} from "../data/menuItems";
import Login from "../pages/Login";
import PrivateRoute from "./PrivateRoute";
import { setMenuType } from "../redux/slice/menuType";
import PageNotAccessible from "../pages/PageNotAccessible";
const AppRoutes = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const menuType = useSelector((state) => state.menuType);

    React.useEffect(() => {
        if (location.pathname.includes("/admin/")) {
            dispatch(setMenuType("admin"));
        }
    }, [location.pathname, dispatch]);

    return (
        <Routes>
            <Route path="/page-restricted" element={<PageNotAccessible />} />
            <Route path="/login" element={<Login />} />
            {/* Research Routes */}
            {researchMenuItems.map((item) => (
                <Route
                    key={item.path}
                    path={item.path}
                    element={
                        <PrivateRoute
                            restrictedRoles={["head_of_sales", "sales"]}
                        >
                            {React.createElement(getRouteComponent(item.path))}
                        </PrivateRoute>
                    }
                />
            ))}

            {corporateMenuItems.map((item) => (
                <Route
                    key={item.path}
                    path={item.path}
                    element={
                        <PrivateRoute restrictedRoles={[]}>
                            {React.createElement(getRouteComponent(item.path))}
                        </PrivateRoute>
                    }
                />
            ))}

            {/* Sales Routes */}
            {salesMenuItems.map((item) => (
                <Route
                    key={item.path}
                    path={item.path}
                    element={
                        <PrivateRoute
                            restrictedRoles={["analyst", "head_of_research"]}
                        >
                            {React.createElement(getRouteComponent(item.path))}
                        </PrivateRoute>
                    }
                />
            ))}

            {/* Admin Routes */}
            {adminMenuItems.map((item) => (
                <Route
                    key={item.path}
                    path={item.path}
                    element={
                        <PrivateRoute
                            restrictedRoles={[
                                "head_of_sales",
                                "sales",
                                "analyst",
                                "hybrid",
                                "head_of_research",
                            ]}
                        >
                            {React.createElement(getRouteComponent(item.path))}
                        </PrivateRoute>
                    }
                />
            ))}

            {/* Hidden Routes */}
            {hiddenRoutes.map((item) => (
                <Route
                    key={item.path}
                    path={item.path}
                    element={React.createElement(item.component)}
                />
            ))}

            {/* Default Route */}
            <Route
                path="/"
                element={
                    <Navigate
                        to={
                            menuType === "admin"
                                ? "/admin/dashboard"
                                : "/research/dashboard"
                        }
                        replace
                    />
                }
            />
            <Route
                path="*"
                element={
                    <Navigate
                        to={
                            menuType === "admin"
                                ? "/admin/dashboard"
                                : "/research/dashboard"
                        }
                        replace
                    />
                }
            />
        </Routes>
    );
};

export default AppRoutes;
